var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { action, makeObservable, observable } from 'mobx';
import { RemoteDataStore } from '../RemoteDataStore';
export class FlightDetailStore extends RemoteDataStore {
    constructor(flightEnrichStore, api) {
        super();
        Object.defineProperty(this, "_flight", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "flightEnrichStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "api", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        makeObservable(this, {
            _flight: observable,
            handleResponse: action,
            clear: action,
        });
        this.flightEnrichStore = flightEnrichStore;
        this.api = api;
    }
    get flight() {
        if (!this._flight) {
            return undefined;
        }
        return this.flightEnrichStore.enrich([this._flight])[0];
    }
    performRequest(params, options) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.api.flights().get(params, options);
        });
    }
    handleResponse(response) {
        return __awaiter(this, void 0, void 0, function* () {
            const [flight] = response.data.flights || [];
            this._flight = flight;
        });
    }
    clear() {
        this._flight = undefined;
    }
}
//# sourceMappingURL=FlightDetailStore.js.map